export default __webpack_public_path__ + "699fcc0ad78f4b9a6c273ac0fc76ac38.png";